import { useRef, useState } from 'react';
import { CheckIcon, CopyIcon } from '@/assets/icons';
import { cn } from '@/libs/utils';
import { Button } from '../button';

export default function CopyClipboard({
  children,
  className,
  value,
  delay = 2000,
  title,
  metadata,
}) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  const performCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setCopied(false);
        timeoutRef.current = null;
      }, delay);
    } catch (err) {
      console.error('Failed to copy text to clipboard', err);
    }
  };

  return (
    <div className={cn('relative flex gap-1', className)} onClick={performCopy}>
      {children}

      <Button
        title={title ?? null}
        className={cn(
          'z-5 relative flex h-6 w-6 cursor-pointer items-center justify-center rounded-md',
          metadata?.className
        )}
      >
        {!copied ? (
          <CopyIcon width={17} height={17} />
        ) : (
          <CheckIcon width={18} height={18} />
        )}

        <span className="sr-only">Copy</span>
      </Button>
    </div>
  );
}
